/**
 * Ba tài liệu tải về từ màn Kết nối nguồn.
 *
 * ── VÌ SAO BA, KHÔNG PHẢI MỘT ─────────────────────────────────────────────
 * Ba tài liệu này đi tới BA NGƯỜI khác nhau, và gộp lại thì mỗi người phải đọc
 * qua hai phần không liên quan tới mình:
 *
 *     DSN          → quản trị cơ sở dữ liệu của khách hàng. Việc của họ là cấp
 *                    một tài khoản chỉ-đọc và mở đường mạng.
 *     GRAPHQL      → người vận hành bên mình, khi khách đã CÓ sẵn endpoint.
 *     CHUAN_VAO    → đội lập trình của khách hàng, khi họ phải VIẾT endpoint.
 *                    Đây là bản hợp đồng: thiếu một trường là bộ đồng bộ hỏng.
 *
 * ── VÌ SAO NỘI DUNG NẰM Ở ĐÂY, KHÔNG QUA CATALOG DỊCH ─────────────────────
 * Đây là TÀI LIỆU XUẤT RA (.docx gửi cho người ngoài), không phải chuỗi màn hình; và
 * `CHUAN_VAO` là hợp đồng kỹ thuật phải khớp từng chữ với bộ đọc GraphQL của backend.
 * Tách ra hàng trăm khoá dịch thì mất cả hai: không đọc được như một văn bản liền, và
 * người sửa adapter không thấy mình phải sửa tài liệu. Chỉ có bản tiếng Việt.
 *
 * Cùng lý do như hướng dẫn khai báo: một `.docx` dựng sẵn trong git thì không
 * đọc được diff, không ai review, và người sửa adapter sẽ quên cập nhật nó. Ở
 * đây, sửa hợp đồng GraphQL và sửa tài liệu là cùng một pull request.
 *
 * ⚠️ `CHUAN_VAO` phải khớp từng chữ với bộ đọc GraphQL (`graphql_adapter`) của
 * backend `tro-ly-ai`. Đội kỹ thuật bên ngoài dựng endpoint theo đúng tài liệu này;
 * lệch một tên trường là một lần triển khai hỏng mà không ai đọc được lý do.
 */

import type { Khoi } from './tao-docx.ts';

export const TEP_DSN = 'Huong-dan-ket-noi-CSDL-DSN.docx';
export const TEP_GRAPHQL = 'Huong-dan-ket-noi-GraphQL.docx';
export const TEP_CHUAN_VAO = 'Chuan-dau-vao-GraphQL-cho-doi-ky-thuat.docx';

// ── ① KẾT NỐI BẰNG CƠ SỞ DỮ LIỆU ─────────────────────────────────────────

export const HD_DSN: Khoi[] = [
  { loai: 'tieuDe', chu: 'Hướng dẫn kết nối cơ sở dữ liệu (DSN)', cap: 1 },
  {
    loai: 'doan',
    chu:
      'Gửi tài liệu này cho **người quản trị cơ sở dữ liệu** của đơn vị. Việc cần thực hiện gồm ' +
      'hai phần: cấp một tài khoản **chỉ đọc** và mở kết nối mạng tới máy chủ.',
  },
  {
    loai: 'doan',
    chu:
      'Nền tảng không chạy trực tiếp câu lệnh của người dùng trên cơ sở dữ liệu của đơn vị. ' +
      'Nền tảng đồng bộ dữ liệu về một kho riêng theo lịch, và mọi câu hỏi được xử lý trên kho đó. ' +
      'Vì vậy tài khoản cấp cho nền tảng chỉ cần quyền **SELECT**, và không bao giờ cần ' +
      'quyền ghi.',
  },

  { loai: 'tieuDe', chu: '1. Thông tin cần cung cấp', cap: 1 },
  { loai: 'gach', chu: '**Loại cơ sở dữ liệu** — PostgreSQL hoặc SQL Server.' },
  { loai: 'gach', chu: '**Máy chủ** — tên miền hoặc địa chỉ IP mà nền tảng gọi tới được.' },
  { loai: 'gach', chu: '**Cổng** — mặc định 5432 (PostgreSQL) hoặc 1433 (SQL Server).' },
  { loai: 'gach', chu: '**Tên cơ sở dữ liệu** cần đọc.' },
  { loai: 'gach', chu: '**Lược đồ (schema)** — thường là `public` (PostgreSQL) hoặc `dbo` (SQL Server).' },
  { loai: 'gach', chu: '**Tài khoản và mật khẩu** chỉ đọc — xem câu lệnh tạo ở mục 2.' },
  {
    loai: 'doan',
    chu:
      'Trên màn Kết nối nguồn, mỗi thông tin ở trên là một ô riêng. Không cần tự ghép ' +
      'chuỗi kết nối; nếu đã có sẵn chuỗi thì dán vào ô cuối, các ô phía trên sẽ được điền tự động.',
  },

  { loai: 'tieuDe', chu: '2. Tạo tài khoản chỉ đọc', cap: 1 },
  { loai: 'doan', chu: '**PostgreSQL**' },
  { loai: 'gach', chu: "CREATE USER doc_bao_cao PASSWORD '…';" },
  { loai: 'gach', chu: 'GRANT CONNECT ON DATABASE ten_csdl TO doc_bao_cao;' },
  { loai: 'gach', chu: 'GRANT USAGE ON SCHEMA public TO doc_bao_cao;' },
  { loai: 'gach', chu: 'GRANT SELECT ON ALL TABLES IN SCHEMA public TO doc_bao_cao;' },
  {
    loai: 'doan',
    chu:
      'Bảng được tạo sau lệnh trên sẽ không tự động có quyền. Để không phải cấp lại mỗi lần, chạy thêm: ' +
      'ALTER DEFAULT PRIVILEGES IN SCHEMA public GRANT SELECT ON TABLES TO doc_bao_cao;',
  },
  { loai: 'doan', chu: '**SQL Server**' },
  { loai: 'gach', chu: "CREATE LOGIN doc_bao_cao WITH PASSWORD = '…';" },
  { loai: 'gach', chu: 'USE ten_csdl;' },
  { loai: 'gach', chu: 'CREATE USER doc_bao_cao FOR LOGIN doc_bao_cao;' },
  { loai: 'gach', chu: 'ALTER ROLE db_datareader ADD MEMBER doc_bao_cao;' },
  {
    loai: 'doan',
    chu:
      'Lưu ý với SQL Server: hệ quản trị này **không có** chế độ chỉ đọc ở mức phiên như PostgreSQL, ' +
      'nên quyền của tài khoản là lớp bảo vệ **duy nhất**. Không cấp `db_owner` để rút ngắn thao tác.',
  },

  { loai: 'tieuDe', chu: '3. Kết nối mạng và bảo mật', cap: 1 },
  {
    loai: 'gach',
    chu:
      'Mở tường lửa cho địa chỉ IP của máy chủ nền tảng tới đúng cổng cơ sở dữ liệu. ' +
      'Liên hệ đội triển khai để lấy địa chỉ IP.',
  },
  {
    loai: 'gach',
    chu:
      'Mật khẩu được tách khỏi chuỗi kết nối và **mã hoá** ngay khi lưu. Khi hiển thị lại ' +
      'về sau, chuỗi chỉ còn dạng `user:***@host/db`.',
  },
  {
    loai: 'gach',
    chu:
      'Nên tạo tài khoản riêng cho nền tảng, không dùng chung tài khoản của ứng dụng: ' +
      'khi cần, có thể thu hồi riêng tài khoản này.',
  },

  { loai: 'tieuDe', chu: '4. Sau khi kết nối', cap: 1 },
  { loai: 'gach', chu: '**Kiểm tra kết nối** — xem tài khoản đọc được bao nhiêu bảng.' },
  { loai: 'gach', chu: '**Tạo kho lưu bản sao** — tạo cơ sở dữ liệu bản sao riêng cho nguồn này.' },
  {
    loai: 'gach',
    chu:
      '**Chọn bảng từ CSDL** ở màn Kho dữ liệu — chọn đúng những bảng có số liệu cần hỏi. ' +
      'Bỏ qua bảng sao lưu, bảng tạm, bảng nhật ký kỹ thuật.',
  },
  { loai: 'gach', chu: '**Đồng bộ ngay**, rồi khai báo nghiệp vụ theo tài liệu Hướng dẫn khai báo nghiệp vụ.' },
  {
    loai: 'doan',
    chu:
      'Kết quả đọc được 0 bảng thường không phải do cơ sở dữ liệu rỗng, mà do thiếu quyền USAGE ' +
      'trên lược đồ. Trên giao diện, hai trường hợp này hiển thị giống hệt nhau.',
  },
];

// ── ② KẾT NỐI BẰNG GRAPHQL ───────────────────────────────────────────────

export const HD_GRAPHQL: Khoi[] = [
  { loai: 'tieuDe', chu: 'Hướng dẫn kết nối nguồn GraphQL', cap: 1 },
  {
    loai: 'doan',
    chu:
      'Dùng cách này khi đơn vị **đã có** (hoặc sẽ xây dựng) một endpoint GraphQL để đọc dữ liệu. ' +
      'Nếu đơn vị chỉ có cơ sở dữ liệu và một người quản trị, hãy dùng cách kết nối DSN — ' +
      'nhanh hơn và không cần lập trình.',
  },
  {
    loai: 'doan',
    chu:
      'Nếu đội kỹ thuật phải **viết mới** endpoint, gửi cho họ tài liệu ' +
      '**Chuẩn đầu vào GraphQL** — đó là bản đặc tả kỹ thuật đầy đủ.',
  },

  { loai: 'tieuDe', chu: '1. Thông tin cần cung cấp', cap: 1 },
  { loai: 'gach', chu: '**Địa chỉ endpoint** — ví dụ https://erp.don-vi.vn/graphql' },
  {
    loai: 'gach',
    chu:
      '**Khoá gọi API** (tuỳ chọn) — nền tảng gửi kèm dạng `Authorization: Bearer <khoá>`. ' +
      'Khoá được lưu mã hoá và không bao giờ hiển thị lại trên màn hình.',
  },
  { loai: 'gach', chu: '**Chu kỳ đồng bộ** — cứ sau bao nhiêu phút thì lấy dữ liệu mới về.' },

  { loai: 'tieuDe', chu: '2. Yêu cầu tối thiểu với endpoint', cap: 1 },
  {
    loai: 'gach',
    chu:
      'Bật **introspection** — nền tảng đọc cấu trúc schema để đề xuất bản khai báo. Nếu tắt, ' +
      'phải khai báo thủ công từng bảng, từng cột.',
  },
  {
    loai: 'gach',
    chu:
      'Mỗi bảng là một **connection kiểu Relay** với `first`, `after`, `pageInfo`, `edges { node }`.',
  },
  {
    loai: 'gach',
    chu:
      'Mỗi bảng có **khoá chính** và (rất nên có) một trường ghi thời điểm sửa gần nhất, ' +
      'kèm tham số `updatedAfter` — nếu thiếu, mỗi chu kỳ phải đồng bộ lại toàn bộ bảng.',
  },
  {
    loai: 'gach',
    chu:
      'Connection **không yêu cầu thêm tham số bắt buộc nào khác** ngoài `first`, `after`, ' +
      '`updatedAfter`. Một connection yêu cầu tham số riêng là một truy vấn có tham số, không phải một bảng.',
  },

  { loai: 'tieuDe', chu: '3. Kết nối mạng và tần suất', cap: 1 },
  { loai: 'gach', chu: 'Endpoint phải gọi được từ máy chủ nền tảng (mở tường lửa nếu cần).' },
  {
    loai: 'gach',
    chu:
      'Nếu có giới hạn tần suất, trả mã lỗi `TOO_MANY_REQUESTS` / `RATE_LIMITED` trong ' +
      '`extensions` — nền tảng sẽ chờ rồi gọi lại thay vì dừng cả chu kỳ.',
  },
  {
    loai: 'gach',
    chu:
      'Nếu có giới hạn kích thước trang, khai báo bằng dữ liệu: `extensions: { maxFirst: 200 }`. Nền tảng tự ' +
      'giảm kích thước trang xuống đúng mức đó.',
  },

  { loai: 'tieuDe', chu: '4. Sau khi kết nối', cap: 1 },
  { loai: 'gach', chu: '**Kiểm tra kết nối** — nền tảng chạy introspection và đếm số bảng đọc được.' },
  { loai: 'gach', chu: '**Tạo kho lưu bản sao**, rồi **Chọn bảng từ CSDL** và **Đồng bộ ngay**.' },
  {
    loai: 'gach',
    chu:
      'Hệ thống của đơn vị có thể chủ động báo "có dữ liệu mới" bằng webhook. Khoá bí mật webhook ' +
      'chỉ hiển thị **đúng một lần** khi tạo nguồn — cần lưu lại ngay.',
  },
];

// ── ③ CHUẨN ĐẦU VÀO GRAPHQL — HỢP ĐỒNG KỸ THUẬT ──────────────────────────

export const HD_CHUAN_VAO: Khoi[] = [
  { loai: 'tieuDe', chu: 'Chuẩn đầu vào GraphQL cho nền tảng FOXAI', cap: 1 },
  {
    loai: 'doan',
    chu:
      'Tài liệu dành cho **đội lập trình** xây dựng endpoint GraphQL. Đây là bản đặc tả kỹ thuật ràng buộc hai bên: ' +
      'nền tảng gọi đúng những truy vấn nêu dưới đây, không nhiều hơn và không khác đi.',
  },
  {
    loai: 'doan',
    chu:
      'Nguyên tắc chung: endpoint chỉ **đọc**. Nền tảng phân trang tuần tự, chọn đúng các ' +
      'trường đã khai báo (không lấy toàn bộ rồi lọc), và không bao giờ gửi câu lệnh do người dùng ' +
      'viết tới endpoint.',
  },

  { loai: 'tieuDe', chu: '1. Introspection', cap: 1 },
  {
    loai: 'doan',
    chu:
      'Nền tảng chạy introspection chuẩn (`__schema { queryType, types { name kind fields ' +
      '{ name args type } } }`) để nhận diện bảng, cột, kiểu dữ liệu và tính nullable. Cần bật introspection, ít nhất ' +
      'cho khoá gọi API của nền tảng.',
  },
  {
    loai: 'gach',
    chu:
      '`description` của type và field được dùng làm gợi ý nhãn nghiệp vụ — viết bằng tiếng Việt ' +
      'giúp bước khai báo nhanh hơn đáng kể.',
  },
  {
    loai: 'gach',
    chu:
      'Kiểu `NON_NULL` được đọc thành cột NOT NULL ở kho. Không khai báo NON_NULL cho trường thực ' +
      'tế có thể rỗng — một giá trị rỗng hợp lệ sẽ làm dừng cả lượt đồng bộ.',
  },

  { loai: 'tieuDe', chu: '2. Mỗi bảng là một connection kiểu Relay', cap: 1 },
  {
    loai: 'doan',
    chu:
      'Trên `Query`, mỗi bảng là một field trả về connection. Ví dụ với bảng hoá đơn:',
  },
  {
    loai: 'gach',
    chu:
      'query($first: Int!, $after: String, $updatedAfter: DateTime) { ' +
      'hoaDon(first: $first, after: $after, updatedAfter: $updatedAfter) { ' +
      'totalCount pageInfo { hasNextPage endCursor } ' +
      'edges { cursor node { id soHoaDon ngayLap thanhTien capNhatLuc } } } }',
  },
  { loai: 'doan', chu: 'Bắt buộc có đủ:' },
  { loai: 'gach', chu: '`first: Int!` — số dòng mỗi trang. `after: String` — con trỏ trang tiếp.' },
  { loai: 'gach', chu: '`pageInfo { hasNextPage endCursor }` — nền tảng dừng khi `hasNextPage = false`.' },
  { loai: 'gach', chu: '`edges { cursor node { … } }` — dữ liệu nằm trong `node`.' },
  {
    loai: 'gach',
    chu:
      '`totalCount` — không bắt buộc nhưng nên có: đây là con số duy nhất cho biết một chu kỳ ' +
      'đã đồng bộ đủ hay dừng giữa chừng.',
  },
  {
    loai: 'doan',
    chu:
      'Con trỏ `after` phải **ổn định**: cùng một con trỏ luôn cho ra cùng một vị trí, kể cả ' +
      'khi có dòng mới chèn vào giữa chừng. Con trỏ tính theo offset sẽ làm mất hoặc trùng lặp ' +
      'dòng khi bảng đang được ghi.',
  },
  {
    loai: 'doan',
    chu:
      'Connection **không được yêu cầu tham số bắt buộc nào khác** ngoài `first`, `after`, ' +
      '`updatedAfter`. Nền tảng không hỗ trợ truyền tham số riêng cho từng bảng.',
  },

  { loai: 'tieuDe', chu: '3. Đồng bộ tăng dần — `updatedAfter`', cap: 1 },
  {
    loai: 'doan',
    chu:
      'Mỗi bảng nên có một trường ghi thời điểm sửa gần nhất (ví dụ `capNhatLuc: DateTime!`) và nhận ' +
      'tham số `updatedAfter: DateTime`. Khi có, nền tảng chỉ lấy những dòng đã thay đổi kể từ thời điểm đó.',
  },
  { loai: 'gach', chu: 'So sánh phải là **lớn hơn hoặc bằng** thời điểm truyền vào, theo UTC.' },
  {
    loai: 'gach',
    chu:
      'Trường này phải được cập nhật **mỗi lần dòng bị sửa**, kể cả khi sửa bởi tác vụ nền. Nếu trường chỉ được ghi ' +
      'lúc tạo, mọi thay đổi về sau sẽ không được đồng bộ về kho và không có lỗi nào được báo.',
  },
  {
    loai: 'gach',
    chu:
      'Không có trường này, việc đồng bộ vẫn hoạt động, nhưng mỗi chu kỳ phải đồng bộ toàn bộ bảng — ' +
      'rất tốn tài nguyên với bảng lớn.',
  },

  { loai: 'tieuDe', chu: '4. Biết dòng nào đã bị xoá', cap: 1 },
  {
    loai: 'doan',
    chu:
      'Đây là phần thường bị bỏ sót nhất, và hậu quả không kèm lỗi nào: bản sao vẫn giữ dòng đã xoá ở ' +
      'nguồn, nên mọi con số tổng đều **cao hơn thực tế**. Có ba cách, chọn một:',
  },
  {
    loai: 'gach',
    chu:
      '**Cách 1 — nhật ký xoá (tốt nhất).** query($table: String!, $since: DateTime!, ' +
      '$first: Int!, $after: String) { deletedRecords(table: $table, since: $since, ' +
      'first: $first, after: $after) { totalCount pageInfo { hasNextPage endCursor } ' +
      'edges { cursor node { table rowId deletedAt } } } }',
  },
  {
    loai: 'gach',
    chu:
      '**Cách 2 — cờ xoá mềm.** Giữ dòng lại kèm một trường boolean (ví dụ `daXoa`) và khai báo ' +
      'trường đó trong bản khai báo. Nền tảng tự loại các dòng mang cờ.',
  },
  {
    loai: 'gach',
    chu:
      '**Cách 3 — đối chiếu khoá.** query($table: String!, $first: Int!, $after: String) ' +
      '{ allKeys(table: $table, first: $first, after: $after) { totalCount ' +
      'pageInfo { hasNextPage endCursor } edges { cursor node } } } — trả về toàn bộ khoá ' +
      'chính đang tồn tại; nền tảng xoá ở bản sao những khoá không còn. Tốn tài nguyên hơn hai cách trên ' +
      'nhưng vẫn nhẹ hơn đồng bộ lại toàn bộ dòng.',
  },
  {
    loai: 'doan',
    chu:
      'Nếu không áp dụng cách nào, bảng bị đánh dấu **giả định chỉ thêm mới**, và cảnh báo này đi kèm ' +
      'mọi câu trả lời dùng dữ liệu của bảng đó.',
  },

  { loai: 'tieuDe', chu: '5. Kiểu dữ liệu', cap: 1 },
  { loai: 'gach', chu: '`ID`, `String` → chuỗi. Với chuỗi rất dài, cần nêu rõ để khai báo thành kiểu text.' },
  { loai: 'gach', chu: '`Int` → số nguyên. Số vượt 2^31 phải dùng kiểu 64-bit riêng và nêu rõ.' },
  {
    loai: 'gach',
    chu:
      '**Tiền và số lượng: không dùng `Float`.** Dùng một scalar `Decimal` trả về chuỗi ' +
      '("1234567.89"). `Float` là số thực nhị phân, gây sai lệch tổng tiền ở phần lẻ — ' +
      'sai số nhỏ nhưng cộng dồn và rất khó truy vết.',
  },
  { loai: 'gach', chu: '`Boolean` → đúng/sai. `DateTime` → chuỗi ISO 8601 kèm múi giờ, ưu tiên UTC.' },
  { loai: 'gach', chu: '`Date` → chuỗi `YYYY-MM-DD`.' },
  {
    loai: 'gach',
    chu:
      'Enum nên trả về **mã ổn định** (`DA_HUY`), không phải nhãn hiển thị — nhãn thay đổi theo ' +
      'giao diện, còn mã thì không.',
  },
  {
    loai: 'doan',
    chu:
      'Trường lồng nhau (object trong object) và mảng không được đồng bộ về kho. Nếu cần dữ liệu ' +
      'bảng con, cung cấp dữ liệu đó dưới dạng một connection riêng, kèm khoá ngoại ở dạng trường phẳng.',
  },

  { loai: 'tieuDe', chu: '6. Lỗi và giới hạn', cap: 1 },
  {
    loai: 'gach',
    chu:
      'Lỗi tạm thời (quá tải, hết thời gian chờ) trả mã trong `extensions`: `TOO_MANY_REQUESTS`, ' +
      '`RATE_LIMITED`, `THROTTLED`, `SERVICE_UNAVAILABLE`, `TIMEOUT`, `UNAVAILABLE`. ' +
      'Nền tảng chờ rồi gọi lại.',
  },
  {
    loai: 'gach',
    chu:
      'Lỗi của bên gọi (sai tên trường, `first` vượt giới hạn) trả lỗi GraphQL thông thường — ' +
      'nền tảng dừng bảng đó và báo người vận hành, không thử lại.',
  },
  {
    loai: 'gach',
    chu:
      'Nếu có giới hạn kích thước trang, khai báo bằng dữ liệu: `extensions: { maxFirst: 200 }`. Nền tảng đọc ' +
      'con số đó và tự giảm kích thước trang.',
  },
  { loai: 'gach', chu: 'HTTP 429 và 5xx cũng được coi là tạm thời.' },

  { loai: 'tieuDe', chu: '7. Xác thực', cap: 1 },
  {
    loai: 'gach',
    chu:
      'Nền tảng gửi `Authorization: Bearer <khoá>` nếu người vận hành đã khai báo khoá. Không có ' +
      'cơ chế đăng nhập nhiều bước.',
  },
  {
    loai: 'gach',
    chu:
      'Cấp khoá **riêng** cho nền tảng, chỉ có quyền đọc, thu hồi được độc lập. Đặt thời hạn sử dụng dài ' +
      'hoặc báo trước khi đổi — khoá hết hạn giữa đêm sẽ làm chu kỳ đồng bộ dừng mà không có cảnh báo.',
  },

  { loai: 'tieuDe', chu: '8. Webhook báo có dữ liệu mới (tuỳ chọn)', cap: 1 },
  {
    loai: 'doan',
    chu:
      'Nếu muốn dữ liệu được cập nhật ngay thay vì chờ lịch, hệ thống của đơn vị gọi địa chỉ webhook do ' +
      'nền tảng cấp, kèm header `X-Notify-Secret` là khoá bí mật chỉ hiển thị một lần khi tạo nguồn. ' +
      'Nền tảng ghi nhận thành thông báo để người vận hành bấm đồng bộ, hoặc để lịch tự chạy.',
  },

  { loai: 'tieuDe', chu: '9. Danh mục kiểm tra trước khi bàn giao', cap: 1 },
  { loai: 'gach', chu: 'Introspection bật, mỗi bảng có `description` bằng tiếng Việt.' },
  { loai: 'gach', chu: 'Mỗi bảng: connection Relay đủ `first`/`after`/`pageInfo`/`edges { node }`.' },
  { loai: 'gach', chu: 'Mỗi bảng có khoá chính phẳng, không rỗng, không đổi theo thời gian.' },
  { loai: 'gach', chu: 'Mỗi bảng có trường ghi thời điểm sửa gần nhất và nhận `updatedAfter`.' },
  { loai: 'gach', chu: 'Đã chọn một trong ba cách báo dòng bị xoá.' },
  { loai: 'gach', chu: 'Tiền và số lượng trả về dạng `Decimal` chuỗi, không phải `Float`.' },
  { loai: 'gach', chu: 'Con trỏ phân trang ổn định khi có dòng mới chèn vào.' },
  { loai: 'gach', chu: 'Lỗi tạm thời có mã trong `extensions`; giới hạn kích thước trang khai báo bằng `maxFirst`.' },
];
